<template>
    <div class="wrapper">
        <div class="page-header page-header-small">
            <parallax class="page-header-image" style="background-image: url('img/ruka.jpg')">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <h4>Komplexní služby v oblasti odpadového hospodářství.</h4>
                        <h1 class="title">OD ROKU 1995</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="about-description text-center">
                <div class="features-3">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-4 mr-auto ml-auto">
                                <card  class="card-nav-tabs" header-classes="card-header-warning">
                                <h4 class="title">sběr olejů k recyklaci</h4>
                                <div>
                                <line-chart :labels="lineChart1.labels" :data="lineChart1.data" :color="lineChart1.color" :height="200">
                                </line-chart>
                                </div>
                                </card>
                            </div>

                            <div class="col-md-4 mr-auto ml-auto">
                                <card  class="card-nav-tabs" header-classes="card-header-warning">
                                <h4 class="title">sběr emulzí</h4>
                                <div>
                                <line-chart :labels="lineChart2.labels" :data="lineChart2.data" :color="lineChart2.color" :height="200">
                                </line-chart>
                                </div>
                                </card>
                            </div>

                            <div class="col-md-4 mr-auto ml-auto">
                                <card  class="card-nav-tabs" header-classes="card-header-warning">
                                <h4 class="title">sběr pevných odpadů</h4>
                                <div>
                                <line-chart :labels="lineChart3.labels" :data="lineChart3.data" :color="lineChart3.color" :height="200">
                                </line-chart>
                                </div>
                                </card>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-8 mr-auto ml-auto">
                                <div class="separator-line separator-primary"></div>
                                <h2 class="title"><router-link class="router-link-item nav-link" to="/spolecnost"> více se o nás dozvíte zde </router-link></h2>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
  import { Card, Button, Badge, InfoSection, FormGroupInput, Checkbox } from '@/components';
  import LineChart from '@/components/Charts/LineChart';
  import { Select, Option } from 'element-ui'

  export default {
    name: 'about-us',
    bodyClass: 'about-us',
    components: {
      Card,
      InfoSection,
      Badge,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput,
      [Select.name]: Select,
      [Option.name]: Option,
      [LineChart.name]: LineChart,
      [Card.name]: Card,
    },
    data() {
      return {
        form: {
          name: '',
          email: '',
          phone: ''
        },
        lineChart1: {
         labels: ["1995","1996","1997","1998","1999","2000","2001","2002","2003","2004","2005","2006","2007","2008","2009","2010","2011","2012","2013","2014","2015","2016","2017","2018","2019","2020",],
         data: [135,673,989,1117,1137,1427,1093,1019,955,1571,2121,2084,1975,2329,2048,2004,1942,1767,1526,1715,1787,2060,2246,2487,2717,3148,],
         color: '#f96332'
       },
        lineChart2: {
         labels: ["1995","1996","1997","1998","1999","2000","2001","2002","2003","2004","2005","2006","2007","2008","2009","2010","2011","2012","2013","2014","2015","2016","2017","2018","2019","2020",],
         data: [97,64,168,261,318,485,762,631,552,624,648,709,1443,1495,1372,1568,1830,1795,1967,871,833,2817,1311,1017,1195,1062,],
         color: '#f96332'
       },
        lineChart3: {
         labels: ["1995","1996","1997","1998","1999","2000","2001","2002","2003","2004","2005","2006","2007","2008","2009","2010","2011","2012","2013","2014","2015","2016","2017","2018","2019","2020",],
         data: [0,0,0,0,0,0,0,0,0,0,70,82,103,188,183,157,185,166,188,201,252,232,207,251,220,227,],
         color: '#f96332'
       }
     }
    }
  }
</script>
<style>
.section {
    padding: 0 0 !important;
}

.about-us {
    padding: 0 0 !important;
}
.about-description, .about-contact {
    padding: 0 0 !important;
}        
.features-3 {
    padding: 20px 0 !important;
}        
.description {
    color: #888 !important;
    font-weight: 500 !important;
}       
.page-header {
    min-height: 60vh !important;
}  

</style>
